import React from "react";
import CalendarIcon from "icons/CalendarIcon.js";

export default function CalendarNote({ details }) {
  return (
    <div className="item Calendar-note has-bubble">
      <div className="item-prefix">
        <CalendarIcon className="calendar-icon" />
      </div>
      <div className="item-stacked-text">
        <div className="calendar-note-name small-heading-txtstyl">
          {details.name}
        </div>
        <div
          className={
            "calendar-note-duration subscript-txtstyl " + details.color_type
          }
        >
          {details.duration + (details.duration > 1 ? " Days" : " Day")}
        </div>
      </div>
    </div>
  );
}
